import { AuthService } from '../services/auth.service';
import { inject } from '@angular/core';
import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandlerFn,
  HttpRequest,
  HttpResponse,
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import { environment } from '../../environments/environment';

export function apiInterceptor(
  request: HttpRequest<unknown>,
  next: HttpHandlerFn
): Observable<HttpEvent<unknown>> {
  const authService = inject(AuthService);
  const headers: { [key: string]: string } = {};

  if (request.url.match(/^\//) != null) {
    const isPublicApi = request.url.match(/^\/v\d+\//);
    let querystring = '';

    let endpoint = isPublicApi ? environment.publicApi : environment.redApi;

    if (authService.tokenJWT) {
      if (isPublicApi) {
        headers['Authorization'] = `Bearer ${authService.tokenJWT}`;
      } else {
        querystring += '?token=' + authService.tokenJWT;
      }
    }

    request = request.clone({
      url: endpoint + request.url + querystring,
      withCredentials: true,
      setHeaders: headers,
    });
  }

  return next(request).pipe(
    tap((result) => {
      if (result instanceof HttpResponse) {
        if (result.headers.get('authorization')) {
          authService.tokenJWT = result.headers.get('authorization') || '';
        }
      }
    }),
    catchError((error: HttpErrorResponse) => {
      console.error('interceptor error : ' + error.message);
      return throwError(() => error);
    })
  );
}
